export const EVENT_NAME = {
  OPEN_QUICK: "Open"
};
